import compareVersions from 'compare-versions';
import FileSaver from 'file-saver';

class Toonsdk {
  /* eslint-disable */
  constructor(platform) {
    if (platform) {
      // 自定义传入平台
      this.platform = platform;
    } else {
      this.platform = this.getPlatform();
    }
    this.errorPlatformTip = '当前平台无法使用toonsdk，请确认程序运行在App里';
    this.wechatDebug = false;
    this.callback = null;
    setTimeout(() => {
      // 异步回调init 保证如果new TOONMIXIN 以后调用complete方法的callback队列可以被执行
      this.init();
    }, 500);
    if (window.VConsole) {
      this.log('开启日志输出！');
    }
  }

  init() {
    switch (this.platform) {
      case 'toongine':
        this.callback && this.callback();
        break;
      case 'toon':
        this.callback && this.callback();
        break;
      case 'wechat': // 微信端需要获取授权签名
        if (typeof wx === 'undefined') {
          throw new Error('如需调用微信api请先引入微信jssdk文件');
        }
        this.getWeChatConfig();
        wx.ready(() => {
          this.callback && this.callback();
        });
        break;
      case 'alipay': // 支付宝需要引入api
        if (typeof ap === 'undefined') {
          throw new Error('如需调用支付宝api请先引入支付宝jssdk文件');
        }
        this.callback && this.callback();
        break;
      case 'alipayMiniprogram':
        if (typeof my === 'undefined') {
          throw new Error('如需调用支付宝小程序api请先引入支付宝jssdk文件');
        }
        console.log('支付宝小程序可用');
        my.onMessage = e => {
          if (e.name == 'scan') {
            this.resolve({ result: e.data.result });
          }
        };
        this.callback && this.callback();
        break;
      case 'mzt': // 闽政通需要额外引入js文件
        if (typeof app === 'undefined') {
          // throw new Error('如需调用闽政通api请先引入闽政通相关js文件')
        }
        this.callback && this.callback();
        break;
      case 'imwork':
        this.callback && this.callback();
        break;
      default:
        if (this.platform === 'toon' || this.platform === 'alipay' || this.platform === 'mzt') {
          console.info(`当前为 [${this.platform}] 可调用相关api`);
        } else {
          console.warn(`当前为 [${this.platform}] 无法调用相关api`);
        }
        this.callback && this.callback();
    }
  }

  log(arg1, arg2) {
    if (window.VConsole) {
      console.log(arg1, arg2);
    }
  }
  formatToongineResult = (res, resolve, reject) => {
    const rst = {
      ...res,
      result: res.data,
      error: res.code,
      message: res.msg,
    };
    console.log('formatToongineResult rst', rst);
    if (rst.error === 0) {
      resolve(rst);
    } else {
      reject(rst);
    }
    return rst;
  };
  mergeParams(paramsOld, paramsNew) {
    this.log('paramsOld:', paramsOld);
    this.log('paramsNew:', paramsNew);
    // !! E福州的安卓不支持多出来的无用参数
    return paramsNew;
  }

  complete(callback) {
    // 配置完成后调用接口
    this.callback = callback;
  }

  getWeChatConfig() {
    const self = this;
    let host = location.href.split('#')[0];
    host = encodeURIComponent(host);
    // let url = `http://218.106.145.208:27018/weixin/getConfig?url=${host}`
    const url = `${location.protocol}//syother.efzhou.com/fuzhou-weixin/api/weixin/getConfig?url=${host}`;
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'json';
    xhr.open('get', url);
    xhr.send();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 304) {
          const param = xhr.response;
          wx.config({
            debug: self.wechatDebug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: param.data.appId, // 必填，公众号的唯一标识
            timestamp: param.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: param.data.nonceStr, // 必填，生成签名的随机串
            signature: param.data.signature, // 必填，签名
            jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareWeibo',
              'onMenuShareQZone',
              'startRecord',
              'stopRecord',
              'onVoiceRecordEnd',
              'playVoice',
              'pauseVoice',
              'stopVoice',
              'onVoicePlayEnd',
              'uploadVoice',
              'downloadVoice',
              'chooseImage',
              'previewImage',
              'uploadImage',
              'downloadImage',
              'translateVoice',
              'getNetworkType',
              'openLocation',
              'getLocation',
              'hideOptionMenu',
              'showOptionMenu',
              'hideMenuItems',
              'showMenuItems',
              'hideAllNonBaseMenuItem',
              'showAllNonBaseMenuItem',
              'closeWindow',
              'scanQRCode',
              'chooseWXPay',
              'openProductSpecificView',
              'addCard',
              'chooseCard',
              'openCard',
            ], // 必填，需要使用的JS接口列表
          });
        } else {
          throw new Error('微信配置接口请求失败!');
        }
      }
    };
  }

  getToonResult(flag) {
    return new Promise((resolve, reject) => {
      const _port = location.href.indexOf('https://') > -1 ? 6781 : 6780;
      const url = `${location.protocol}//127.0.0.1:${_port}/getResult`;
      const data = { flagId: flag };
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'json';
      xhr.open('POST', url);
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send(`params=${JSON.stringify(data)}`);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 304) {
            resolve(xhr.response);
          } else {
            reject(xhr.status);
          }
        }
      };
    });
  }

  out_of_china(lng, lat) {
    return lng < 72.004 || lng > 137.8347 || lat < 0.8293 || lat > 55.8271 || false;
  }

  transformlat(lng, lat) {
    const PI = 3.1415926535897932384626;
    let ret =
      -100.0 +
      2.0 * lng +
      3.0 * lat +
      0.2 * lat * lat +
      0.1 * lng * lat +
      0.2 * Math.sqrt(Math.abs(lng));
    ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
    ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0;
    ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0;
    return ret;
  }

  transformlng(lng, lat) {
    const PI = 3.1415926535897932384626;
    let ret =
      300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng));
    ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0;
    ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0;
    ret +=
      ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0;
    return ret;
  }

  wgs84togcj02(lng, lat) {
    const x_PI = (3.14159265358979324 * 3000.0) / 180.0;
    const PI = 3.1415926535897932384626;
    const a = 6378245.0;
    const ee = 0.00669342162296594323;
    if (this.out_of_china(lng, lat)) {
      return [lng, lat];
    }
    let dlat = this.transformlat(lng - 105.0, lat - 35.0);
    let dlng = this.transformlng(lng - 105.0, lat - 35.0);
    const radlat = (lat / 180.0) * PI;
    let magic = Math.sin(radlat);
    magic = 1 - ee * magic * magic;
    const sqrtmagic = Math.sqrt(magic);
    dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI);
    dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI);
    const mglat = lat + dlat;
    const mglng = lng + dlng;
    return [mglng, mglat];
  }

  imgToBase64(url) {
    const canvas = document.createElement('canvas');
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    return new Promise((resolve, reject) => {
      try {
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const base64 = canvas.toDataURL('image/jpg');
          resolve(base64);
        };
      } catch (err) {
        reject(err);
      }
      img.onerror = err => {
        console.log('err');
        reject(err);
      };
    });
  }

  base64ToFile(base64, suffix) {
    const bstr = atob(base64);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${new Date().getTime()}.${suffix}`, {
      type: `image/${suffix}`,
    });
  }

  wxToBase64(url) {
    return new Promise((resolve, reject) => {
      wx.getLocalImgData({
        // 获取本地图片
        localId: url,
        success: res => {
          const { localData } = res;
          if (localData.indexOf('base64') >= 0) {
            resolve(localData);
          } else {
            resolve(`data:image/png;base64,${localData}`);
          }
        },
        fail: err => {
          reject(err);
        },
      });
    });
  }

  chooseImage(params) {
    // 选择图片
    var params = params || {};
    const _this = this;
    switch (this.platform) {
      case 'toongine':
        return new Promise((resolve, reject) => {
          // todo handleResult=0有问题，会关闭h5页面
          toongine.media.chooseImage({
            params,
            callback: (resFormat => {
              const images = [];
              const imageType = resFormat.data && resFormat.data.imageType ? resFormat.data.imageType : 'png';
              const imageArr = resFormat.data.map(val => {
                images.push(`data:image/${imageType};base64,${val.base64}`);
                val.originalFileObj = this.base64ToFile(val.base64, imageType);
                return val;
              });
              return this.formatToongineResult({ ...resFormat, images, imageArr }, resolve, reject)
            }),
          });
        });
      case 'toon':
        const flagId = new Date().getTime();

        const param = this.mergeParams(params, {
          flagId,
          nameSpace: params.nameSpace || 'demo.systoon.com',
          functionType: params.functionType == null ? 2 : params.functionType, // 功能类型 0-直接调用相机 1-直接从相册选择 2-弹出选择框，相机或者相册
          filterMimeType: params.filterMimeType || 'image/gif', // 例如：image/gif,image/png,image/jpeg(以","为分隔符，现在只支持以上三种类型的过滤)
          maxCount: params.maxCount || 9,
          ratio: params.ratio || 0.1,
        });
        if (params.type == 0) {
          param.type = 0;
          param.aspectX = params.aspectX;
          param.aspectY = params.aspectY;
          param.xLength = params.xLength;
          param.yLength = params.yLength;
        } else {
          param.type = 1;
        }
        this.log('param:', param);
        window.location.href = `toon://mwap/photo?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            this.log('chooseImage resp:', resp);
            const images = [];

            const imageType = resp.data && resp.data.imageType ? resp.data.imageType : 'png';
            if (resp.data.base64) {
              images.push(`data:image/${imageType};base64,${resp.data.base64}`);
              return Promise.resolve({
                ...resp.data,
                images,
                originalFileObj: this.base64ToFile(resp.data.base64, imageType),
              });
            }
            const imageArr = resp.data.imageArr.map(val => {
              images.push(`data:image/${imageType};base64,${val.base64}`);
              val.originalFileObj = this.base64ToFile(val.base64, imageType);
              return val;
            });
            return Promise.resolve({ ...resp.data, images, imageArr });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      case 'wechat':
        return new Promise((resolve, reject) => {
          let typeArr;
          if (params.functionType === 0) {
            typeArr = ['camera'];
          } else if (params.functionType === 1) {
            typeArr = ['album'];
          } else {
            typeArr = ['album', 'camera'];
          }
          wx.chooseImage(
            this.mergeParams(params, {
              count: params.maxCount || 9, // 默认9
              sizeType: params.retio === 1 ? ['original'] : ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
              sourceType: typeArr, // 可以指定来源是相册还是相机，默认二者都有
              success(res) {
                Promise.all(
                  res.localIds.map(val => {
                    return _this.wxToBase64(val);
                  }),
                ).then(imgs => {
                  resolve({ images: imgs });
                });
              },
              fail(err) {
                reject(err);
              },
            }),
          );
        });
      case 'alipayMiniprogram':
        console.log('chooseimage-mini');
        return new Promise((resolve, reject) => {
          let typeArr;
          if (params.functionType === 0) {
            typeArr = ['camera'];
          } else if (params.functionType === 1) {
            typeArr = ['album'];
          } else {
            typeArr = ['album', 'camera'];
          }
          my.chooseImage(
            this.mergeParams(params, {
              count: params.maxCount || 9, // 默认9
              sourceType: typeArr, // 可以指定来源是相册还是相机，默认二者都有
              success(resp) {
                Promise.all(
                  resp.apFilePaths.map(val => {
                    return _this.imgToBase64(val);
                  }),
                ).then(imgs => {
                  resolve({ images: imgs });
                });
              },
              fail(err) {
                reject(err);
              },
            }),
          );
        });
      case 'alipay':
        let typeArr;
        if (params.functionType === 0) {
          typeArr = ['camera'];
        } else if (params.functionType === 1) {
          typeArr = ['album'];
        } else {
          typeArr = ['album', 'camera'];
        }
        return ap
          .chooseImage(
            this.mergeParams(params, {
              count: params.maxCount || 9, // 默认9
              sourceType: typeArr, // 可以指定来源是相册还是相机，默认二者都有
            }),
          )
          .then(resp => {
            console.log(resp);
            return Promise.all(
              resp.apFilePaths.map(val => {
                return _this.imgToBase64(val);
              }),
            );
          })
          .then(imgs => {
            return Promise.resolve({ images: imgs });
          })
          .catch(err => Promise.reject(err));

      case 'mzt':
        // let type = params.functionType == null ? 2 : params.functionType
        return new Promise((resolve, reject) => {
          window.mztMiniApp.getTakePictures(
            { quality: params.quality, count: params.maxCount },
            function (res) {
              // console.log('闽政通选择图片', res);
              const images = [];
              res.images.map(val => {
                images.push(`data:image/png;base64,${val}`);
              });
              resolve({
                ...res,
                images,
              });
            },
            this.mergeParams(params, {
              pictureNum: params.maxCount || 9,
              compressKB: params.ratio ? params.ratio * 100 : 100,
            }),

            function (error) {
              console.log('闽政通选择图片失败', error);
            },
          );
          // app.link.getTakePictures(
          //   function (res) {
          //     const images = [];
          //     res.images.map(val => {
          //       images.push(`data:image/png;base64,${val}`);
          //     });
          //     resolve({
          //       ...res,images,
          //     });
          //   },
          //   this.mergeParams(params,{
          //     pictureNum: params.maxCount || 9,
          //     compressKB: params.ratio ? params.ratio * 100 : 100,
          //   }),
          // );
        });
      // 启达只提供文件路径，使用sdk没有意义
      // case 'imwork':
      //   return new Promise((resolve, reject) => {
      //     imdevice.fm.chooseFile({
      //       type: 'image',
      //       limit: params.maxCount,
      //       success: data => {
      //         this.log('scan success chooseFile', data);
      //         resolve({
      //           result: data.value,
      //         });
      //       },
      //       fail: err => {
      //         this.log('scan fail chooseFile', data);
      //         reject(err);
      //       },
      //     });
      //   });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getLiveFace(params) {
    // 人脸识别
    switch (this.platform) {
      case 'toongine':
        return new Promise((resolve, reject) => {
          toongine.tcCertEngin.housekeeping.checkFaceImageEngin({
            params,
            callback: res => {
              const rst = this.formatToongineResult(res, resolve, reject);
            },
          });
        });
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
        };
        window.location.href = `toon://bjrealname/fetchFaceImageDataRouter?params=${JSON.stringify(
          param,
        )}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ liveFace: `data:image/png;base64,${resp.data.base64}` });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      case 'alipayMiniprogram':
        alert('支付宝端暂不支持人脸识别功能');
        break;
      case 'wechat':
        alert('微信端暂不支持人脸识别功能');
        break;
      case 'alipay':
        alert('支付宝端暂不支持人脸识别功能');
        break;
      case 'mzt':
        return new Promise((resolve, reject) => {
          // console.log('需要验证人员信息',params.userName,params.userIdCard)
          window.mztMiniApp.faceCheck(
            { userName: params.userName, userIdCard: params.userIdCard },
            function (res) {
              console.log(res);
              resolve(res);
            },
            function (error) {
              console.log(error);
              reject(error);
            },
          );
          // app.link.getFaceCheck(
          //   result => {
          //     resolve({ liveFace: `data:image/png;base64,${result.images}` });
          //   },
          //   err => {
          //     reject(err);
          //   },
          //   {
          //     isNeedInputUserInfo: 0,
          //     isNeedIdentification: 0,
          //   },
          // );
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  scan(params) {
    this.log('scan params', params,this.platform);
    // 扫描二维码
    var params = params || {};
    switch (this.platform) {
      case 'toongine':
        return new Promise((resolve, reject) => {
          // todo handleResult=0有问题，会关闭h5页面
          toongine.device.scanCode({
            params,
            callback: res => this.formatToongineResult(res, resolve, reject),
          });
        });

      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          ...{},
          ...params,
          ...{
            flagId,
            handleResult: params.handleResult == null ? 1 : params.handleResult, // ( 0：不处理扫描结果 1：处理扫描结果)
          },
        };
        window.location.href = `toon://qrcode/scan?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data.result });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      case 'wechat':
        return new Promise((resolve, reject) => {
          let type = 0;
          if (params.handleResult != null) {
            type = params.handleResult == 1 ? 0 : 1;
          }
          wx.scanQRCode({
            needResult: type, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
            success(res) {
              resolve({
                result: res.resultStr,
              });
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipayMiniprogram':
        return new Promise((resolve, reject) => {
          my.postMessage({ name: 'scan' });
          this.resolve = resolve;
          this.reject = reject;
        });
      case 'alipay':
        return ap
          .scan()
          .then(resp => Promise.resolve({ result: resp.code }))
          .catch(err => Promise.reject(err));
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.scanQRCode(
            {},
            function (res) {
              console.log('window.mztMiniApp.scanQRCode:',res.code,res);
              resolve({ result: res.code });
            },
            function (error) {
              // console.log(error);
              console.log('window.mztMiniApp.scanQRCode-error:',error);
              reject(err);
            },
          );
          // app.barcode.scan(
          //   function (res) {
          //     resolve({ result: res });
          //   },
          //   function (err) {
          //     reject(err);
          //   },
          // );
        });
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.utils.scan({
            success: data => {
              this.log('scan success data', data);
              resolve({
                result: data.value,
              });
            },
            fail: err => {
              this.log('scan fail data', data);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getNetwork() {
    // 获取网络状态  无入参
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
        };
        window.location.href = `toon://mwap/network?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ networkType: resp.data.typeName });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      case 'wechat':
        return new Promise((resolve, reject) => {
          wx.getNetworkType({
            success(res) {
              resolve({
                networkType: res.networkType,
              });
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipayMiniprogram':
        return new Promise((resolve, reject) => {
          my.getNetworkType({
            success(resp) {
              resolve({ networkType: resp.networkType });
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipay':
        return ap
          .getNetworkType()
          .then(resp => Promise.resolve({ networkType: resp.networkType }))
          .catch(err => Promise.reject(err));
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.getDeviceNetStatus(
            {},
            function (res) {
              let networkType = '';
              switch (res.type) {
                case 0: {
                  networkType = '无网络';
                  break;
                }
                case 1: {
                  networkType = '移动数据';
                  break;
                }
                case 2: {
                  networkType = 'WiFi';
                  break;
                }
                case 3: {
                  networkType = 'Agent';
                  break;
                }
              }
              resolve({
                networkType,
              });
            },
            function () {
              console.log('取消');
            },
          );
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getLocation(params) {
    // 获取经纬度 无参数
    var params = params || {};
    switch (this.platform) {
      case 'toongine':
        return new Promise((resolve, reject) => {
          toongine.location.getLocation({
            params,
            callback: res => {
              const rst = this.formatToongineResult(res, resolve, reject);
            },
          });
        });
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
        };
        window.location.href = `toon://mwap/gps?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ data: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      case 'wechat':
        return new Promise((resolve, reject) => {
          wx.getLocation({
            type: params.type || 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success(res) {
              resolve({
                data: res,
              });
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipayMiniprogram':
        return new Promise((resolve, reject) => {
          my.getLocation({
            ...params,
            success(resp) {
              resolve({ data: resp });
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipay':
        return ap
          .getLocation(params)
          .then(resp =>
            Promise.resolve({
              data: resp,
            }),
          )
          .catch(err => Promise.reject(err));
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.getCurrentLocation(
            {},
            function (res) {
              resolve({
                data: res,
              });
            },
            function (error) {
              resolve({
                data: res,
              });
            },
          );
          // app.getLocation(
          //   function (res) {
          //     resolve({
          //       data: res,
          //     });
          //   },
          //   function (error) {
          //     reject(error);
          //   },
          // );
        });
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.map.locate({
            success: data => {
              // this.log('getLocation success data', data);
              resolve({
                data: data,
              });
            },
            fail: err => {
              // this.log('getLocation fail data', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  openMap(params) {
    // 打开地图
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          latitude: params.latitude || '39.999',
          longitude: params.longitude || '116.451',
        };
        window.location.href = `toon://mwap/map?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ networkType: resp.data.typeName });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      case 'wechat':
        const arr = this.wgs84togcj02(params.longitude, params.latitude);
        params.longitude = arr[0];
        params.latitude = arr[1];
        wx.openLocation(params);
        break;
      case 'alipayMiniprogram':
        return new Promise((resolve, reject) => {
          my.openLocation({
            longitude: params.longitude,
            latitude: params.latitude,
            name: params.name || '',
            address: params.address || '',
            scale: params.scale || 19,
            success(resp) {
              resolve(resp);
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipay':
        const { longitude, latitude } = params;
        ap.openLocation({
          longitude,
          latitude,
          name: params.name || '',
          address: params.address || '',
          scale: params.scale || 19,
        });
        break;
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.getAroundAddressInfo(
            { latitude: params.latitude, longitude: params.longitude },
            function (res) {
              // console.log(res);
              resolve(res);
            },
            function (error) {
              // console.log(error);
              reject(error);
            },
          );
        });
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.map.view({
            longitude: params.longitude || '39.999',
            latitude: params.latitude || '116.451',
            title: params.title || '',
            address: params.address || '',
            success: data => {
              // this.log('mapview success data', data);
              resolve({
                result: data,
              });
            },
            fail: err => {
              this.log('mapview fail data', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  closeWindow(params) {
    switch (this.platform) {
      case 'toon':
        const param = {
          functionType: 1,
        };
        window.location.href = `toon://mwap/window?params=${JSON.stringify(param)}`;
      case 'wechat':
        wx.closeWindow();
        break;
      case 'alipayMiniprogram':
        my.navigateBack();
        break;
      case 'alipay':
        ap.popWindow();
        break;
      case 'mzt':
        // app.goback();
        window.mztMiniApp.goback();
        break;
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.webview.close({
            name: params.name,
            success: data => {
              this.log('webview.close success data', data);
              resolve({
                result: data,
              });
            },
            fail: err => {
              this.log('webview.close fail data', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  openWindow(params) {
    // 打开新窗口
    if (params == null) {
      throw new Error('openWindow参数不能为空，应为url字符串');
    }
    switch (this.platform) {
      case 'toon':
        const param = {
          authLevel: 'L1',
          jumpURL: params.url,
        };
        window.location.href = `toon://openappwithauthlevel/openApp?params=${JSON.stringify(
          param,
        )}`;
        break;
      case 'wechat':
        window.location.href = params;
        break;
      case 'alipayMiniprogram':
        window.location.href = params;
        break;
      case 'alipay':
        ap.pushWindow(params);
        break;
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.jumpMZTWeb(
            { title: params.title, url: params.url },
            function (res) {
              console.log(res);
              resolve(res);
            },
            function (error) {
              console.log(error);
              reject(error);
            },
          );
        });

        // app.link.goOpenNewPageOrExit({
        //   url: params,
        //   exit: true,
        // });
        break;
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.webview.open({
            url: params.url,
            title: params.title || '',
            bgcolor: params.bgcolor || '',
            color: params.color || '',
            hidden: params.hidden || '',
            type: params.type || '',
            leftMenu: params.leftMenu || '',
            rightMenu: params.rightMenu || '',
            closePage: params.closePage || '',
            success: data => {
              this.log('webview.open success data', data);
              resolve({
                result: data,
              });
            },
            fail: err => {
              this.log('webview.open fail data', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  // 设置窗体
  setWindow(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.webview.set({
            title: params.title || '', // 标题 空为取网页的Title
            bgcolor: params.bgcolor || '', // 背景颜色 背景颜色
            color: params.color || '', // 颜色 字体颜色 默认 #fffff
            hidden: params.hidden || '', // 导航条是否显示 导航条 0限藏 1显示
            type: params.type || '', // 打开类型 默认为0 0/1 内置/系统
            rightMenu: params.rightMenu || '', // 右菜单 icon为URL地址图片,event为字符串，js全局的脚本函数
            closePage: params.closePage || '', // 关闭的页面 当前地址为 closePage,点返回关闭而不是后退，解决第一页跳转，第二页是首页的问题
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  openWebFile(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.webview.openWebFile({
            hostUrl: params.hostUrl || '', // 地址 服务器url
            fileId: params.fileId || '', // 标题
            isPGFFormat: params.isPGFFormat || '', // PGF格式打开
            readOnly: params.readOnly || '', // 只读模式
            userName: params.userName || '', // 当前用户名
            isScreenshotForbid: params.isScreenshotForbid || '', // 是否防截屏
            enterReviseMode: params.enterReviseMode || '', // 是否修订模式
            showReviewingPane: parmas.showReviewingPane || '', // 是否显示修订痕迹右侧边栏
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  setShare(params) {
    // 设置分享内容
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        return new Promise((resolve, reject) => {
          try {
            console.log('setShare-toon:', params);
            Array.from(document.getElementsByClassName('shareImgUrl')).map(dom => {
              dom.setAttribute('content', params.imgUrl);
            });
            Array.from(document.getElementsByClassName('shareTitle')).map(dom => {
              dom.setAttribute('content', params.title);
            });
            Array.from(document.getElementsByClassName('shareContent')).map(dom => {
              dom.setAttribute('content', params.content);
            });
            Array.from(document.getElementsByClassName('shareUrl')).map(dom => {
              dom.setAttribute('content', params.url);
            });
            resolve('success');
          } catch (err) {
            reject(err);
          }
        });
      case 'wechat':
        return new Promise((resolve, reject) => {
          wx.updateAppMessageShareData({
            title: params.title, // 分享标题
            desc: params.content, // 分享描述
            link: params.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: params.imgUrl, // 分享图标
            success() {
              // 设置成功
              resolve('success');
            },
            fail(err) {
              reject(err);
            },
          });
        });
      case 'alipayMiniprogram':
        my.startShare();
        break;
      case 'alipay':
        return new Promise((resolve, reject) => {
          try {
            const meta = document.getElementsByTagName('meta');
            console.log(meta);
            meta['Alipay:title'].setAttribute('content', params.title);
            meta['Alipay:imgUrl'].setAttribute('content', params.imgUrl);
            meta['Alipay:desc'].setAttribute('content', params.content);
            meta['Alipay:link'].setAttribute('content', params.url);
            resolve('success');
          } catch (err) {
            reject(err);
          }
        });
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.share(
            {
              title: params.title,
              content: params.content,
              imageUrl: params.imgUrl,
              linkUrl: params.url,
            },
            function (res) {
              console.log(res);
            },
            function (error) {
              console.log(error);
            },
          );
          // try {
          //   app.link.shareWebPage(
          //     params.title,
          //     params.content,
          //     params.imgUrl,
          //     params.url,
          //     () => {
          //       resolve('success');
          //     },
          //     err => {
          //       reject(err);
          //     },
          //   );
          // } catch (err) {
          //   reject(err);
          // }
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  openShare(params) {
    // 设置分享内容
    var params = params || {};
    const { imgUrl, url, title, content, shareChannel, shareMessageText, attachData } = params;
    // console.log('toonsdk-openShare:',params)
    switch (this.platform) {
      case 'toon':
        const param = {
          shareContent: {
            shareChannel:
              shareChannel ||
              'shareToon,shareToonCircle,shareWeChat,shareWeChatCircle,shareWeiBo,shareQQ,shareQQSpace,shareMessage',
            // 默认的分享
            shareImageUrl: imgUrl,
            shareUrl: url,
            shareTitle: title,
            shareText: content,
            // 分享到toon
            shareToonImageUrl: imgUrl,
            shareToonUrl: url,
            shareToonTitle: title,
            shareToonText: content,
            // 分享到toon社交圈
            shareToonCircleImageUrl: imgUrl,
            shareToonCircleUrl: url,
            shareToonCircleTitle: title,
            shareToonCircleText: content,
            // 分享到微信好友
            shareWeChatImageUrl: imgUrl,
            shareWeChatUrl: url,
            shareWeChatTitle: title,
            shareWeChatText: content,
            // 分享到微信朋友圈
            shareWeChatCircleImageUrl: imgUrl,
            shareWeChatCircleUrl: url,
            shareWeChatCircleTitle: title,
            shareWeChatCircleText: content,
            // 分享到微博
            shareWeiBoImageUrl: imgUrl,
            shareWeiBoUrl: url,
            shareWeiBoTitle: title,
            shareWeiBoText: content,
            // 分享到qq
            shareQQImageUrl: imgUrl,
            shareQQUrl: url,
            shareQQTitle: title,
            shareQQText: content,
            // 分享到qq空间
            shareQQSpaceImageUrl: imgUrl,
            shareQQSpaceUrl: url,
            shareQQSpaceTitle: title,
            shareQQSpaceText: content,
            // 短信内容
            shareMessageText: shareMessageText || '',
            // 附加内容
            attachData: attachData || '',
          },
        };
        window.location.href = `toon://mwap/h5usenativeshare?params=${JSON.stringify(param)}`;
        return Promise.resolve({});
      // case 'wechat':
      //   return new Promise((resolve, reject) => {
      //     wx.updateAppMessageShareData({
      //       title: params.title, // 分享标题
      //       desc: params.content, // 分享描述
      //       link: params.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //       imgUrl: params.imgUrl, // 分享图标
      //       success() {
      //         // 设置成功
      //         resolve('success');
      //       },
      //       fail(err) {
      //         reject(err);
      //       },
      //     });
      //   });
      // case 'alipayMiniprogram':
      //   my.startShare();
      //   break;
      // case 'alipay':
      //   return new Promise((resolve, reject) => {
      //     try {
      //       const meta = document.getElementsByTagName('meta');
      //       console.log(meta);
      //       meta['Alipay:title'].setAttribute('content', params.title);
      //       meta['Alipay:imgUrl'].setAttribute('content', params.imgUrl);
      //       meta['Alipay:desc'].setAttribute('content', params.content);
      //       meta['Alipay:link'].setAttribute('content', params.url);
      //       resolve('success');
      //     } catch (err) {
      //       reject(err);
      //     }
      //   });
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.share(
            {
              title: params.title,
              content: params.content,
              imageUrl: params.imgUrl,
              linkUrl: params.url,
            },
            function (res) {
              console.log(res);
            },
            function (error) {
              console.log(error);
            },
          );
          // try {
          //   app.link.shareWebPage(
          //     title,
          //     content,
          //     imgUrl,
          //     url,
          //     () => {
          //       resolve('success');
          //     },
          //     err => {
          //       reject(err);
          //     },
          //   );
          // } catch (err) {
          //   reject(err);
          // }
        });
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.utils.startShareMenu({
            url: url,
            shareUrl: url,
            title: title,
            intro: content,
            image: imgUrl,
            success: data => {
              this.log('startShareMenu success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('startShareMenu fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  chooseCard(params) {
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          type: params.type,
        };
        window.location.href = `toon://card/chooseCard?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            // alert(JSON.stringify(resp));
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  createGroup(params) {
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          userId: params.userId, //userId(必选-string):用户id
          cardFeedId: params.cardFeedId, //cardFeedId(必选-string):创建者的名片feedId
        };
        if (params.broadcastCategory) {
          params.broadcastCategory = params.broadcastCategory; //broadcastCategory(可选-string):小组分类("101@旅游")
        }
        if (params.name) {
          params.name = params.name; //name(可选-string):小组名称
        }
        if (params.spreadTitle) {
          params.spreadTitle = params.spreadTitle; //spreadTitle(可选-string):小组的介绍
        }
        if (params.groupLogo) {
          params.groupLogo = params.groupLogo; //groupLogo(可选-string):小组头像地址
        }
        if (params.enrollType) {
          params.enrollType = params.enrollType; //enrollType(可选-string)=参加规则（2:邀请;1:申请;0:开放;）
        }
        if (params.isSpecifyLocation) {
          params.isSpecifyLocation = params.isSpecifyLocation; //isSpecifyLocation(可选-string):位置策略(0指定, 1隐藏, 2未指定)
        }
        if (params.address) {
          params.address = params.address; //address(可选-string):指定地址(isSpecifyLocation=0时必选)
        }
        if (params.lat) {
          params.lat = params.lat; //lat(可选-string):经度(isSpecifyLocation=0时必选)
        }
        if (params.lng) {
          params.lng = params.lng; //lng(可选-string):纬度(isSpecifyLocation=0时必选)
        }
        if (params.memberListString) {
          params.memberListString = params.memberListString; //memberListString(可选-string):成员列表("c1,c2,c3")
        }

        window.location.href = `toon://group/createGroup?params=${JSON.stringify(param)}`;
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.createGroup({
            success: data => {
              this.log('getCreateGroup success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getCreateGroup fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  setGroup(params) {
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          userId: params.userId, //userId(必选-string):用户id
          vFeedId: params.cardFeedId, //vFeedId(必选-string): 访问者名片feedId
          sFeedId: params.sFeedId, //sFeedId(必选-string): 要设置的小组feedId
        };
        window.location.href = `toon://group/setGroup?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  aloneChat(params) {
    // 单聊会话
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          myCardNo: params.myCardNo, // 自己的名片id
          friendCardNo: params.friendCardNo, // 好友的名片
        };
        window.location.href = `toon://chat?params=${JSON.stringify(param)}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  myFriends(params) {
    // 我的好友
    const flagId = new Date().getTime();
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          feedId: params.feedId, // 我的名片Id
          cardNo: params.cardNo, // 我的名片No
          flagId,
        };
        window.location.href = `toon://contact/friends?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ data: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  myColleagues(params) {
    // 我的同事
    const flagId = new Date().getTime();
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          feedId: params.feedId, // 我的名片Id
          cardNo: params.cardNo, // 我的名片No
          flagId,
        };
        window.location.href = `toon://contact/colleagues?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ data: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getDiscoveryAround(params) {
    // 发现模块（周边）
    const flagId = new Date().getTime();
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        let param = {
          coordinate: params.coordinate, // (必选)经纬度
          viewType: params.viewType, // (必选)页面类型: 1:交友(不限), 2:交友(男), 3:交友(女), 4:小区, 5:学校, 6:景区, 7:兴趣群组, 8:活动
          flagId,
        };
        if (params.title) {
          param.title = params.title;
        } //(可选)页面标题
        if (params.accessType) {
          param.accessType = params.accessType;
        } //（可选）访问页面类型：0：浏览页面（默认）；1：选择名片
        window.location.href = `toon://discovery/around?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ data: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getDiscoveryGroup(params) {
    // 发现模块（群组）
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        window.location.href = 'toon://discovery/group';
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  showFrame(params) {
    // 显示frame
    const flagId = new Date().getTime();
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        let param = {
          feedId: params.feedId, // 需要显示的名片或群组ID
        };
        if (params.myFeedId) {
          param.myFeedId = params.myFeedId;
        } // 可选参数，我的名片ID
        window.location.href = `toon://frame?params=${JSON.stringify(param)}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getGroupChat(params) {
    // 群聊会话
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        let param = {
          myCardNo: params.myCardNo, // 自己在群聊中的名片Id
          groupChatId: params.groupChatId, // 群聊的Id
        };
        window.location.href = `toon://groupChat?params=${JSON.stringify(param)}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  creatGroupChat(params) {
    // 创建群聊
    const flagId = new Date().getTime();
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          groupName: params.groupName, // 群聊名称
          createFeedId: params.createFeedId, // 创建者feedId，必须是自己的feedId
          userId: params.userId, // userId
          name: params.name, // 名称
          headImage: params.headImage, //头像
          title: params.title, //导航栏title
          members: params.members, // 其他群聊成员数组
          feedId,
        };
        window.location.href = `toon://groupChat/creat?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ data: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  joinGroupChat(params) {
    // 加入群聊
    const flagId = new Date().getTime();
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          groupId: params.groupId, // 群聊id
          feedId: params.feedId, // 必须是自己的feedId
          userId: params.userId, // userId
          name: params.name, // 名称
          headImage: params.headImage, //头像
          title: params.title, //导航栏title
          operatorFeedId: params.operatorFeedId, // 操作者ID
          requestCode: params.requestCode, // 请求码
          feedId,
        };
        window.location.href = `toon://groupChat/joinMyself?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve();
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getNotify() {
    //通知中心 主页面
    switch (this.platform) {
      case 'toon':
        window.location.href = 'toon://notify/main';
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getNotifyCatalog(params) {
    //通知中心 消息分类页
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          appId: params.appId, // appId
        };
        window.location.href = `toon://notify/catalog?params=${JSON.stringify(param)}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getCashRegister(params) {
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          args: {
            buyerId: params.buyerId, //String 买家id 买家toon用户id 必填
            buyerType: params.buyerType, //String 买家类型(01：个人普；02：商户) 01：个人 必填
            sellerId: params.sellerId, //String 卖家id 卖家toon用户id 必填
            sellerType: params.sellerType, //String 卖家类型 01：个人；02：商户（普通）；03：商户（收单结算）； 必填
            tradeType: params.tradeType, //String 交易类型，普通交易实时到账，担保交易 普通交易：normal；担保交易：guarantee 必填
            merNo: params.merNo, //String 商户号，从支付平台获取 如：101003 必填
            txAmount: params.txAmount, //long 金额 如：300（分） 必填
            outOrderNo: params.outOrderNo, //String 订单号  必填
            body: params.body, //String 商品名称  必填
            subject: params.subject, //String 商品详情  必填
            txTime: params.txTime || new Date().getTime(), //String 下单时间(当前时间) 时间戳 必填
          },
        };
        if (params.extrInfo) {
          params.extrInfo = params.extrInfo; //String 交易扩展信息  非必填
        }
        if (params.notifyUrl) {
          params.notifyUrl = params.notifyUrl; //String 回调地址  非必填
        }
        if (params.userVcard) {
          params.userVcard = params.userVcard; //String 买家名片feedId  非必填
        }
        if (params.userVcardName) {
          params.userVcardName = params.userVcardName; //String 买家名片名称  非必填
        }
        if (params.mobile) {
          params.mobile = params.mobile; //String 买家手机号 非必填
        }
        if (params.sellerVcard) {
          params.sellerVcard = params.sellerVcard; //String 卖家名片id  非必填
        }
        if (params.sellerVcardName) {
          params.sellerVcardName = params.sellerVcardName; //String 卖家名片名称  非必填
        }
        if (params.sellerMobile) {
          params.sellerMobile = params.sellerMobile; //String 卖家手机号  非必填
        }
        window.location.href = `toon://toonpay/checkoutPayCash?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            // alert('失败' + JSON.stringify(err));
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  openRedEnvelope(params) {
    switch (this.platform) {
      case 'toon':
        const param = {
          fromFeedId: params.fromFeedId, //String  红包发送方feedId    必填
          operatorFeedId: params.operatorFeedId, //String  红包接收方feedId    必填
          redPacketId: params.redPacketId, //String  红包id    必填
          remark: params.remark, //String  备注    非必填
          recvType: params.recvType, //String  红包类型  1：普通红包（固定金额）2：拼手气（随机金额）  必填
        };
        window.location.href = `toon://luckymoney/unpack?params=${JSON.stringify(param)}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  qrcodeShow(params) {
    switch (this.platform) {
      case 'toon':
        const param = {
          feedId: params.feedId, //feedId(名片或群组的ID,cardNo groupNo)
        };
        window.location.href = `toon://qrcode/show?params=${JSON.stringify(param)}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  SetGps() {
    switch (this.platform) {
      case 'toon':
        window.location.href = `toon://mwap/gps`;

      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getReferFriend(params) {
    // alert('进入');
    switch (this.platform) {
      case 'toon':
        const param = {
          myFeedId: params.myFeedId, //myFeedId:(必填)我的名片 ID
        };
        window.location.href = `toon://recommendFriends/recommendFriend?params=${JSON.stringify(
          param,
        )}`;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getShock(params) {
    switch (this.platform) {
      case 'toon':
        window.location.href = `toon://mwap/vibrate`;
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.vibrate({
            duration: params.duration || '400',
            success: data => {
              this.log('vibrate success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('vibrate fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  copy(params) {
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const param = {
          content: params.content, //content(需要复制到剪贴板的内容) 例如：”思源集团“ 必选
        };
        window.location.href = `toon://mwap/clipboard?params=${JSON.stringify(param)}`;
      case 'mzt':
        return new Promise((resolve, reject) => {
          window.mztMiniApp.copyBoard(
            { text: params.content },
            function (res) {
              console.log('复制成功：', res);
            },
            function (error) {
              console.log('复制失败:', error);
            },
          );
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  switchScreen(params) {
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          orientation: params.orientation,
        };
        window.location.href = `toon://mwap/screenorientation?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            // alert(JSON.stringify(resp));
            return Promise.resolve({ result: JSON.stringify(resp) });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getAudioRecord(params) {
    // alert('录音2')
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          filename: param.filename, // 文件名
          maxDuration: param.maxDuration, // int 设置最大时长，默认60s,最大可设置180s
        };
        window.location.href = `toon://mwap/audioRecord?params=${JSON.stringify(params)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            alert(JSON.stringify(resp));
            return Promise.resolve({ result: JSON.stringify(resp) });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getChooseVideo(params) {
    // alert('视频2')
    var params = params || {};
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
          filename: params.filename, // 文件名
          maxDuration: params.maxDuration, // int 设置最大时长，默认60s,最大可设置180s
          sourceType: params.sourceType, // 0用户选择，1录像，2相册选择
        };
        window.location.href = `toon://mwap/chooseVideo?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            console.log('getToonResult-success', resp);
            return Promise.resolve({ result: JSON.stringify(resp) });
          })
          .catch(err => {
            console.log('getToonResult-err', err);
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getAlert(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.alert({
            title: params.title, // 标题
            message: params.message, // 消息
            confirmButtonText: params.confirmButtonText, // 确定按钮文本
            success: data => {
              this.log('alert success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('alert fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getConfirm(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.confirm({
            title: params.title, // 标题
            message: params.message, // 消息
            confirmButtonText: params.confirmButtonText, // 确定按钮文本
            cancelButtonText: params.cancelButtonText, //取消按钮文本
            success: data => {
              this.log('confirm success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('confirm fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getPrompt(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.prompt({
            message: params.message, // 消息
            defaultValue: params.defaultValue, //缺省值
            confirmButtonText: params.confirmButtonText, // 确定按钮文本
            cancelButtonText: params.cancelButtonText, //取消按钮文本
            success: data => {
              this.log('prompt success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('prompt fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getToast(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.toast({
            message: params.message, // 消息
            duration: params.duration, // 多少秒自动关闭
            success: data => {
              this.log('prompt success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('prompt fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getActionSheet(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.actionSheet({
            message: params.message, // 消息
            cancelButtonText: params.cancelButtonText, //取消按钮文本
            buttons: params.buttons, // 按钮
            success: data => {
              this.log('actionSheet success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('actionSheet fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getMultiSelect(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.multiSelect({
            options: params.options, // 选项
            selectOptions: params.selectOptions, //选中的值
            success: data => {
              this.log('multiSelect success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('multiSelect fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getShowLoading(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.showLoading({
            message: params.message, // 消息
            success: data => {
              this.log('showLoading success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('showLoading fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getHideLoading(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.notify.hideLoading({
            success: data => {
              this.log('hideLoading success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('hideLoading fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getContactsChoose(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.contacts.choose({
            limit: params.limit, // 选择个数 , -1表示不限
            type: params.type, //选择类型 user/dept/all
            selected: params.selected, //已选择
            success: data => {
              this.log('showLoading success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('showLoading fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getCalendarDatePicker(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.calendar.datepicker({
            format: params.format, // 格式
            value: params.value, //值
            success: data => {
              this.log('datepicker success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('datepicker fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getCalendarTimePicker(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.calendar.timepicker({
            format: params.format, // 格式
            value: params.value, //值
            success: data => {
              this.log('timepicker success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('timepicker fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getCalendarDateTimePicker(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.calendar.datetimepicker({
            format: params.format, // 格式
            value: params.value, //值
            success: data => {
              this.log('datetimepicker success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('datetimepicker fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getSelectFile(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.fm.chooseFile({
            type: params.type, // 选择类型 *,image,video
            limit: params.limit, // 选择个数 , 0表示不限
            success: data => {
              this.log('getSelectFile success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getSelectFile fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getDownloadFile(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.fm.downloadFile({
            url: params.url, // 文件地址
            name: params.name, // 文件名 如果没填，就是URL地址里的文件名
            success: data => {
              this.log('downloadFile success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('downloadFile fail err', err);
              reject(err);
            },
          });
        });
      default:
        return new Promise((resolve, reject) => {
          this.log('不是所有浏览器和所有文件都支持，需要App浏览器适配！！');
          FileSaver.saveAs(params.url, params.name);
          resolve({});
        });
    }
  }
  getCheckFile(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.fm.previewFile({
            url: params.url, // 文件地址
            name: params.name, // 文件名 如果没填，就是URL地址里的文件名
            success: data => {
              this.log('downloadFile success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('downloadFile fail err', err);
              reject(err);
            },
          });
        });
      default:
        return new Promise((resolve, reject) => {
          this.log('不是所有浏览器和所有文件都支持，需要App浏览器适配！！');
          // (.doc|.DOC|.xlsx|.xls|.ppt|.pptx)$
          // window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(params.url)}`);
          window.open(params.url);
          resolve({});
        });
    }
  }

  getViewImage(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.fm.previewImage({
            files: params.files, // 相关图片
            index: params.index, // 缺省第几张
            success: data => {
              this.log('getViewImage success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getViewImage fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getRecordVideo(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          console.log('进入录制视频，调用SDK前');
          imdevice.video.startRecord({
            max_duration: params.max_duration, // 最大时长 默认60秒
            success: data => {
              this.log('getRecordVideo success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getRecordVideo fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getPlayVideo(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          console.log('进入播放视频，调用SDK前');
          imdevice.video.play({
            file: params.file, // 地址 默认60秒
            success: data => {
              this.log('getPlayVideo success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getPlayVideo fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getStartRecording(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          console.log('开始录制，调用SDK前，参数type:', params.type);
          imdevice.camera.record({
            type: params.type, // 录制类型 none/video/image 默认60秒
            success: data => {
              this.log('getStartRecording success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getStartRecording fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getOpenLocalApp(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.open({
            url: params.url, // 地址
            query: params.query, // 参数
            success: data => {
              this.log('getOpenLocalApp success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getOpenLocalApp fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getConversationList() {
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.conversationList({
            success: res => {
              this.log('getConversationList success res:', res);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getDialogue(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.dialogue({
            targetType: params.targetType, // 对话目标类型 user/group
            targetId: params.targetId, // 对话目标ID
            fail: err => {
              this.log('getDialogue fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getAddressList() {
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.addressList({
            success: res => {
              this.log('getAddressList success res:', res);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getFriendSearch() {
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.friendSearch({
            success: res => {
              this.log('friendSearch success res:', res);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getUserInfo(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.userInfo({
            id: params.id, // 人员ID
            fail: err => {
              this.log('getUserInfo fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getGroupInfo(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.app.groupInfo({
            id: params.id, // 群组ID
            fail: err => {
              this.log('getGroupInfo fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }

  getLoginInfo() {
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.utils.getLoginInfo({
            success: data => {
              this.log('getLoginInfo success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getLoginInfo fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getStartLocalApp(params) {
    var params = params || {};
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          imdevice.utils.startLocalApp({
            appcode: params.appcode, // 应用code
            targetId: params.targetId, // 应用下属ID
            success: data => {
              this.log('getStartLocalApp success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getStartLocalApp fail err', err);
              reject(err);
            },
          });
        });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getVersion() {
    switch (this.platform) {
      case 'imwork':
        return new Promise((resolve, reject) => {
          console.log('得到版本，调用SDK前');
          imdevice.utils.getVersion({
            success: data => {
              this.log('getVersion success data', data);
              resolve(data);
            },
            fail: err => {
              this.log('getVersion fail err', err);
              reject(err);
            },
          });
        });
      case 'toon':
        let ua = `${window.navigator.userAgent.toLowerCase()}miniprogram`;
        console.log('getVersion:', ua);
        const pos = ua.indexOf('toon');
        let version = '';
        if (pos !== -1) {
          const splitIndex = ua.indexOf(' ', pos);
          version = ua.slice(pos + 5, splitIndex);
        }
        return version;
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getFlagNumber() {
    /*生成32位随机流水号*/
    /*默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1*/
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < 32; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  }
  /**
   * 获取网络身份认证因子数据
   * @param bizSeq 由调用方生成的具有唯一性的业务序列号，不允许包含"&"字符，长度为 32 个字符，建议纯数字32 字符串。 
   * @param type iOS 为 字 符串 类 型/Android 为 int 类型 , 0: 网络身份凭证1: 网络身份凭证+口令6: 电子证照出示

   * @returns 
   */
  getCertInfo(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const flag = this.getFlagNumber();
        const param = {
          flagId,
          bizSeq: params.bizSeq ? params.bizSeq : flag,
          type: params.type,
        };
        window.location.href = `toon://ctid/getCertInfo?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getSealCert(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const flag = this.getFlagNumber();
        const param = {
          flagId,
          ...params,
          bizSeq: params.bizSeq ? params.bizSeq : flag,
        };
        console.log('getSealCert:', param);
        window.location.href = `toon://ctid/getSealCert?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getAuthenticationData(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const flag = this.getFlagNumber();
        const param = {
          flagId,
          ...params,
          bizSeq: params.bizSeq ? params.bizSeq : flag,
        };
        window.location.href = `toon://ctid/getAuthenticationData?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  getAuthenticationDataWithIdentityNum(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const flag = this.getFlagNumber();
        const param = {
          flagId,
          ...params,
          bizSeq: params.bizSeq ? params.bizSeq : flag,
        };
        window.location.href = `toon://ctid/getAuthenticationDataWithIdentityNum?params=${JSON.stringify(
          param,
        )}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  midConsistencyCheck(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const param = {
          flagId,
          ...params,
        };
        window.location.href = `toon://ctid/midConsistencyCheck?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  openUniwallet() {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const param = {
          flagId,
        };
        window.location.href = `toon://ctid/openUniwallet?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  canOpenUniwallet() {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用网络身份认证');
        }
        const flagId = new Date().getTime();
        const param = {
          flagId,
        };
        window.location.href = `toon://ctid/canOpenUniwallet?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  edcFileRead(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用电子证照');
        }
        const flagId = new Date().getTime();
        const param = {
          flagId,
          title: params.title,
          fileUrl: params.fileUrl,
        };
        window.location.href = `toon://ehandsignature/EDCFileRead?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  ofdFileRead(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用电子证照');
        }
        const flagId = new Date().getTime();
        const param = {
          flagId,
          title: params.title,
          fileUrl: params.fileUrl,
        };
        window.location.href = `toon://ehandsignature/OFDFileRead?params=${JSON.stringify(param)}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  ofdSignFile(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        if (version && compareVersions(version, '6.6.9') === -1) {
          return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用电子证照');
        }
        const flagId = new Date().getTime();
        const param = {
          mode: params.mode,
          fileUrl: params.fileUrl,
        };
        if (params.mode === '3') {
          param.x = params.x;
          param.y = params.y;
          param.page = params.page;
        } else if (params.mode === '4') {
          param.goPage = params.goPage;
          param.y = params.y;
          param.key = params.key;
          param.keyindex = params.keyindex;
        }
        const newParam = {
          flagId,
          paramsJson: JSON.stringify(param),
        };
        console.log('OFDSignFile:', newParam);
        window.location.href = `toon://ehandsignature/OFDSignFile?params=${JSON.stringify(
          newParam,
        )}`;
        return this.getToonResult(flagId)
          .then(resp => {
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  openMiniAppWithExtra(params) {
    switch (this.platform) {
      case 'toon':
        const version = this.getVersion();
        console.log('version:', version);
        // if (version && compareVersions(version, '6.6.9') === -1) {
        //   return Promise.reject('你的e福州版本过低，请升级到最新版本后再使用');
        // }
        const flagId = new Date().getTime();
        const param = {
          appletId: params.appletId,
          appletPath: params.appletPath,
          extraData: params.extraData || '',
          appletProgramType: params.appletProgramType || 0,
        };
        console.log('openMiniAppWithExtra:', param);
        window.location.href = `toon://appCenter/openMiniAppWithExtra?params=${JSON.stringify(
          param,
        )}`;
        return this.getToonResult(flagId)
          .then(resp => {
            console.log('this.getToonResult:', resp);
            return Promise.resolve({ result: resp.data });
          })
          .catch(err => {
            console.log('this.getToonResult-err:', err);
            return Promise.reject(err);
          });
      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  openCTID() {
    switch (this.platform) {
      case 'toon':
        const flagId = new Date().getTime();
        const param = {
          flagId,
        };
        const ua = `${window.navigator.userAgent.toLowerCase()}miniprogram`;
        let url = `toon://ctidPrivider/openCTID`;
        const isIos = ua.indexOf('iphone') !== -1;
        if (isIos) {
          url = `toon://ctid/checkctid?params=${JSON.stringify(param)}`;
        } else {
          window.location.href = url;
        }
        console.log('ua:', ua, ua.indexOf('iphone'), url);
        window.location.href = url;
        if (isIos) {
          return this.getToonResult(flagId)
            .then(resp => {
              return Promise.resolve({ result: resp.data });
            })
            .catch(err => {
              return Promise.reject(err);
            });
        }

      default:
        return Promise.reject(new Error(this.errorPlatformTip));
    }
  }
  
  getPlatform() {
    // 获取当前平台
    try {
      const ua = `${window.navigator.userAgent.toLowerCase()}miniprogram`;
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return 'wechat';
      }
      if (ua.match(/toongine/i) == 'toongine') {
        return 'toongine';
      }
      if (ua.match(/toon/i) == 'toon') {
        return 'toon';
      }
      if (ua.match(/mzt/i) == 'mzt') {
        return 'mzt';
      }
      if (ua.match(/alipay/i) == 'alipay') {
        if (ua.match(/miniprogram/i) == 'miniprogram') {
          // 支付宝小程序
          return 'alipayMiniprogram';
        }
        return 'alipay';
      }
      if (ua.match(/imwork/i) == 'imwork') {
        // 启达
        return 'imwork';
      }
      return 'browser';
    } catch (error) {
      console.log('error:', error);
    }
  }
}

export default Toonsdk;
/* eslint-disable */
